import './../../../node_modules/bootstrap-datepicker/dist/css/bootstrap-datepicker3.css';
import './../../../node_modules/bootstrap-datepicker/dist/js/bootstrap-datepicker.js';
import './../../../node_modules/bootstrap-datepicker/dist/locales/bootstrap-datepicker.cs.min.js';

$(document).ready(function()
{
    // Force consistent locale settings across browsers/OSes.
    $.fn.datepicker.dates.cs.daysShort = ['Ne', 'Po', 'Út', 'St', 'Čt', 'Pá', 'So'];
    $.fn.datepicker.dates.cs.daysMin = ['Ne', 'Po', 'Út', 'St', 'Čt', 'Pá', 'So'];

    $.fn.datepicker.defaults.language = 'cs';
    $.fn.datepicker.defaults.weekStart = 1;
    $.fn.datepicker.defaults.defaultViewDate = new Date();

    $(':text[data-provide="datepicker"]').datepicker(
        {
            language: 'cs',
            weekStart: 1,
            defaultViewDate: new Date()
        });
});
